/**
 * Doplní ikonky sociálních sítí do mobilního menu.
 *
 * Šuplík s menu je soubor tématu (snippets/header-drawer.liquid), do kterého
 * záměrně nesaháme, aby ho update Horizonu nepřepsal. Odkazy se proto vkládají
 * až v prohlížeči. Adresy sítí přicházejí z nastavení patičky jako JSON.
 *
 * Téma umí hlavičku překreslit přes Section Rendering API (třeba po přidání
 * do košíku), takže po každé změně v hlavičce ikonky doplníme znovu.
 */
(() => {
  const dataEl = document.querySelector('[data-pp-social]');
  if (!dataEl) return;

  let links = [];
  try {
    links = JSON.parse(dataEl.textContent).filter((item) => item.url);
  } catch {
    return;
  }
  if (!links.length) return;

  const ICONS = {
    instagram:
      '<rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.7"/><circle cx="17.2" cy="6.8" r="1.1" fill="currentColor"/>',
    facebook:
      '<path d="M13.6 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.25-1.5 1.55-1.5H16.8V3.6c-.3-.04-1.3-.13-2.46-.13-2.44 0-4.11 1.49-4.11 4.22V9.9H7.5V13h2.73v8z" fill="currentColor"/>',
    tiktok:
      '<path d="M14.3 3h2.5c.2 1.6 1.1 3 2.9 3.3v2.5c-1.1 0-2.1-.3-3-.9v5.7a5.6 5.6 0 1 1-5.6-5.6c.3 0 .5 0 .8.05v2.6a3 3 0 1 0 2.2 2.9z" fill="currentColor"/>',
  };

  const build = () => {
    const list = document.createElement('div');
    list.className = 'pp-social';
    list.setAttribute('data-pp-social-row', '');

    for (const item of links) {
      const a = document.createElement('a');
      a.className = 'pp-social__link';
      a.href = item.url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', item.label);
      a.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">${ICONS[item.key] ?? ''}</svg>`;
      list.append(a);
    }
    return list;
  };

  const inject = () => {
    document.querySelectorAll('.menu-drawer__utility-links').forEach((slot) => {
      if (slot.querySelector('[data-pp-social-row]')) return;
      slot.append(build());
    });
  };

  inject();

  const header = document.getElementById('header-component');
  if (header) {
    new MutationObserver(inject).observe(header, { childList: true, subtree: true });
  }
})();
